<template>
  <div class="my-group">
  <van-tabs @click="loser">
  <van-tab title="拼团中">
    <div class="spelling" v-for="item in list" :key="item.usergroup_id" @click="lookteam(item)">
      <div class="top">
        <span>订单编号：</span><span>{{item.usergroup_userordersn}}</span>
        <span class="span1">拼团中</span>
      </div>
       <div class="image-text">
         <div class="left">
           <img :src="item.usergroup_shopgroupimg">
         </div>
         <div class="right">
           <p>{{item.usergroup_shopgrouptitle}}</p>
           <span>{{item.usergroup_shopgroupprojectname}}</span><br>
           <span>距离结束时间仅剩：</span><span><van-count-down :time="item.usergroup_shopgroupendtime - item.now" /></span>
         </div>
       </div>
       <div class="money">
          <div class="span1"><span class="order">订单金额：</span><span class="price">¥{{item.usergroup_shopgroupjoinprice}}</span></div>
       </div>
       <div class="friend">
         <div class="icon"></div><span>还差</span><span class="mount">{{item.usergroup_shopgroupjoinnumber - item.usergroup_count}}人</span><span>拼团成功</span>
         <!-- <div class="button1" @click="inviter">邀请好友</div> -->
       </div>
    </div>
    <div v-if="list.length == 0">
    <div class="empty"></div>
    <div class="state">暂无相关数据</div>
    <div class="once" @click="leave">前往拼团</div>
    </div>
  </van-tab>
  <van-tab title="待支付">
    <!-- <div class="defaults"></div> -->
    <div class="spelling" v-for="item in list" :key="item.usergroup_id">
      <div class="top">
        <span>订单编号：</span><span>{{item.usergroup_userordersn}}</span>
        <span class="span1"><van-count-down :time="item.usergroup_shopgroupendtime - item.now" /></span>
        <span class="span1">待支付</span>
      </div>
       <div class="image-text">
         <div class="left">
           <img :src="item.usergroup_shopgroupimg">
         </div>
         <div class="right">
           <p>{{item.usergroup_shopgrouptitle}}</p>
           <span>{{item.usergroup_shopgroupprojectname}}</span><br>
           <span>距离结束时间仅剩：</span><span><van-count-down :time="time" /></span>
         </div>
       </div>
       <div class="money">
          <div class="span1"><span class="order">订单金额：</span><span class="price">¥{{item.usergroup_shopgroupjoinprice}}</span></div>
       </div>
       <div class="friend">
         <div class="button1" @click="payment(item)">立即支付</div>
       </div>
    </div>
     <div v-if="list.length == 0">
    <div class="empty"></div>
    <div class="state">暂无相关数据</div>
    <div class="once" @click="leave">前往拼团</div>
    </div>
  </van-tab>
  <van-tab title="拼团成功">
    <div class="spellings" v-for="item in list" :key="item.usergroup_id" @click="lookgroup(item)">
      <div class="top">
        <span>订单编号：</span><span>{{item.usergroup_userordersn}}</span>
        <span class="span1">拼团成功</span>
      </div>
       <div class="image-text">
         <div class="left">
           <img :src="item.usergroup_shopgroupimg">
         </div>
         <div class="right">
           <p>{{item.usergroup_shopgrouptitle}}</p>
           <span>{{item.usergroup_shopgroupprojectname}}</span><br>
           <span>距离结束时间仅剩：</span><span><van-count-down :time="time" /></span>
         </div>
       </div>
       <div class="money">
          <div class="span1"><span class="order">订单金额：</span><span class="price">¥{{item.usergroup_shopgroupjoinprice}}</span></div>
       </div>
    </div>
     <div v-if="list.length == 0">
    <div class="empty"></div>
    <div class="state">暂无相关数据</div>
    <div class="once" @click="leave">前往拼团</div>
    </div>
  </van-tab>
  <van-tab title="拼团失败">
     <div class="spelling" v-for="item in list" :key="item.usergroup_id">
      <div class="top">
        <span>订单编号：</span><span>{{item.usergroup_userordersn}}</span>
        <span class="span1">超时未支付</span>
      </div>
       <div class="image-text">
         <div class="left">
           <img :src="item.usergroup_shopgroupimg">
         </div>
         <div class="right">
           <p>{{item.usergroup_shopgrouptitle}}</p>
           <span>{{item.usergroup_shopgroupprojectname}}</span><br>
           <span>距离结束时间仅剩：</span><span><van-count-down :time="item.usergroup_shopgroupendtime - item.now" /></span>
         </div>
       </div>
       <div class="money">
          <div class="span1"><span class="order">订单金额：</span><span class="price">¥{{item.usergroup_shopgroupjoinprice}}</span></div>
       </div>
       <div class="friend">
         <div class="button1" v-show="item.now < item.usergroup_shopgroupendtime" @click="again(item)">再次拼团</div>
          <!-- <div class="button1" v-show="showing" @click="again(item)">再次拼团</div> -->
         <div class="button2" v-show="item.now > item.usergroup_shopgroupendtime">活动已经结束</div>
       </div>
    </div>
     <div v-if="list.length == 0">
    <div class="empty"></div>
    <div class="state">暂无相关数据</div>
    <div class="once" @click="leave">前往拼团</div>
    </div>
  </van-tab>
</van-tabs>
  </div>
</template>

<script>
import {api_group,api_goods} from '@/common/Request.js';
import Moment from 'moment'
export default {
  data() {
    return {
      // token: 'MjI2NywxNTg3NjA3NzU4LDE4ODYyMTAxNDk4',
      token:'',
      statustype:'',
      list:[],
      time:'',
      times: '',
      showing:true,
      shows: false
    }
  } ,
  created() {
	  if(this.$route.query.statustype!='')
	  {
		  this.loser(this.$route.query.statustype);
	  }
	  else{
		  this.getList();
	  }
    
  },
  methods: {
    // 待支付
      payment(item) {
        // console.log("item",item);

        this.$router.push({path:'payment_group',query:{usergroup_userordersn:item.usergroup_userordersn,usergroup_shopgroupid:item.usergroup_shopgroupid,usergroup_userorderid:item.usergroup_userorderid,usergroup_shopgroupjoinprice:item.usergroup_shopgroupjoinprice}})
      },
      inviter() {
        this.$router.push({path:'group_detail'})
      },
      getList() {
        this.statustype = 0
        this.token = this.$cookies.get("user_token");
		api_group.myusergroup_list(100,0,this.token,this.statustype).then(res=>{
          const list = res.data
          console.log('list',list)
          const starttime = (new Date()).valueOf()
          list.forEach(index => {
              // const starttime = +new Date(index.usergroup_shopgroupendtime)
              index.usergroup_shopgroupendtime = (new Date(this.formatstr(index.usergroup_shopgroupendtime))).valueOf()
              // const time = endtime - starttime
              // const times = Moment(time).format('HH:mm:ss')
              // this.times = time
              // if( endtime < starttime) {
              //   this.shows = true
              //   this.showing = false
              // }
              // console.log('222',this.times)
               index.now = (new Date()).valueOf()
          });
           this.list = res.data
        })
      },
      loser(item) {
        this.statustype = item
        this.token = this.$cookies.get("user_token")
        // console.log(this.statustype)
        api_group.myusergroup_list(100,0,this.token,this.statustype).then(res=>{
          const lists = res.data
          // console.log('res',res.data);
          // const starttime = (new Date()).valueOf()
          lists.forEach(index => {
              // const starttime = +new Date(index.usergroup_shopgroupendtime)
              //  const endtime = (new Date(this.formatstr(index.usergroup_shopgroupendtime))).valueOf()
              index.usergroup_shopgroupendtime = (new Date(this.formatstr(index.usergroup_shopgroupendtime))).valueOf()
              // const time = endtime - starttime
              // const times = Moment(time).format('HH:mm:ss')
              //  if( endtime < starttime) {
              //   this.shows = true
              //   this.showing = false
              // }
              index.now = (new Date()).valueOf()
              // this.time = time
              // console.log('11',endtime)
          });
          console.log('res',res.data);

          this.list = res.data
        })
      },
      // 查看我的团
      lookteam(item) {
        const id = 1
        console.log('item',item);
        this.$router.push({path:'group_detail',query:{id:id,usergroup_count:item.usergroup_count,usergroup_id:item.usergroup_id,usergroup_shopgroupid:item.usergroup_shopgroupid,usergroup_userordersn:item.usergroup_userordersn,usergroup_userordertime:item.usergroup_userordertime}})
        // this.$router.push({path:'group_detail',query:{item:item}})
      },
      //
      lookgroup(item) {
        // console.log('item',item);
        const id = 2
        this.$router.push({path:'group_detail',query:{id:id,usergroup_count:item.usergroup_count,usergroup_id:item.usergroup_id,usergroup_shopgroupid:item.usergroup_shopgroupid,usergroup_userordersn:item.usergroup_userordersn,usergroup_userordertime:item.usergroup_userordertime}})
        // this.$router.push({path:'group_detail',query:{item:item}})
      },
      leave() {
        this.$router.push({path:'group_booking'})
      },
    //再次拼团
    again(item) {
      // console.log(item)
      this.$router.push({path:'detail_page',query:{shopgroup_id:item.usergroup_shopgroupid}})
    },
    formatstr(timestr)
    {
       timestr=timestr.replace(/-/g,"/");
       return timestr;
    }
    // again() {
    //   this.$router.push({path:'group_booking'})
    // }
    }
}
</script>

<style scoped>
.my-group {
  background-color: #f3f3f3;;
}
  .defaults {
    width: 6.6875rem /* 107/16 */;
    height: 6.5rem /* 104/16 */;
    background: url('/img/kong.png') no-repeat;
    background-size: 100% 100%;
  }
  .spelling {
    margin-top: .3125rem /* 5/16 */;
    height: 16.875rem /* 270/16 */;
    width: 100%;
    background-color: #fff;
  }
  .spellings {
    margin-top: .3125rem /* 5/16 */;
    height: 14.125rem /* 210/16 */;
    width: 100%;
    background-color: #fff;
  }
  .top {
    height: 2.8125rem /* 45/16 */;
    border-bottom: 1px solid #f3f3f3;
    line-height: 2.8125rem /* 45/16 */;
    font-size: .75rem /* 12/16 */;
    color: #333;
    padding-left: .9375rem /* 15/16 */;
    padding-right: .9375rem /* 15/16 */;
  }
  .top .span1 {
    float: right;
  }
  .image-text {
    padding-top: .75rem /* 12/16 */;
    height: 7.5rem /* 120/16 */;
    width: 100%;
    /* background-color: pink; */
	display: flex;
    border-bottom: 1px solid #f3f3f3;
  }
  .left {
    height: 5.375rem /* 86/16 */;
    /*width: 9.375rem /* 150/16 */;
	flex:0 0 40%;
    /* background-color: yellow; */
    margin-left: .9375rem /* 15/16 */;
    float: left;
  }
  .left img {
    height: 100%;
    width: 100%;
  }
  .right {
    height: 5.375rem /* 86/16 */;
    /*width: 11.6875rem /* 187/16 */;
    /* background-color: green; */
    /*float: left;*/
	flex:0 0 50%;
    margin-left: .625rem /* 10/16 */;
  }
  .right p {
    font-size: .875rem /* 14/16 */;
    height: 2.5rem /* 40/16 */;
  }
  .right span {
    font-size: .75rem /* 12/16 */;
    color: #A9A9A9;
  }
  .money {
    height: 2.8125rem /* 45/16 */;
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
    line-height: 2.8125rem /* 45/16 */;
  }
   .money .span1 {
     float: right;
     margin-right: .9375rem /* 15/16 */;
   }
  .money .order {
    font-size: .75rem /* 12/16 */;
    color: #333333;
  }
  .money .price {
    font-size: 1.125rem /* 18/16 */;
  }
  .friend {
    height: 3.75rem /* 60/16 */;
    width: 100%;
    /* background-color: pink; */
    box-sizing: border-box;
    padding-top: .5375rem /* 15/16 */;
    padding-right: .9375rem /* 15/16 */;
  }
  .friend span {
    font-size: .6875rem /* 11/16 */;
    color: #333333;
  }
  .friend .mount {
    color: red;
  }
  .friend .icon {
    margin-left: .9375rem /* 15/16 */;
    margin-right: .9375rem;
    display: inline-block;
    height: .8125rem /* 13/16 */;
    width: .9375rem /* 15/16 */;
    background: url('/img/tuanyuan.png') no-repeat;
    background-size: 100% 100%;
  }
  .friend .button1 {
    text-align: center;
    font-size: .8125rem /* 13/16 */;
    color: white;
    line-height: 1.75rem;
    width: 5.3125rem /* 85/16 */;
    height: 1.75rem /* 28/16 */;
    background-color: #FE5A59;
    /* display: inline-block; */
    border-radius: .1875rem /* 3/16 */;
    margin-left: 7.875rem /* 254/16 */;
    float: right;
  }
  .friend .button2 {
    text-align: center;
    font-size: .8125rem /* 13/16 */;
    color: white;
    line-height: 1.75rem;
    width: 5.3125rem /* 85/16 */;
    height: 1.75rem /* 28/16 */;
    background-color: #BEBEBE;
    /* display: inline-block; */
    border-radius: .1875rem /* 3/16 */;
    margin-left: 7.875rem /* 254/16 */;
    float: right;
  }
  van-tab {
    position: relative;
  }
  .empty {
    width: 6.6875rem /* 107/16 */;
    height: 6.5rem /* 104/16 */;
    background: url('/img/kong.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 16rem;
    left:50%;
    transform:translate(-50%,-50%);
  }
  .once {
    position: absolute;
    width: 9.375rem /* 150/16 */;
    height: 2.5rem /* 40/16 */;
    background-color: #1AAC19;
    top: 30rem;
    left:50%;
    transform:translate(-50%,-50%);
    border-radius: .1875rem /* 3/16 */;
    text-align: center;
    line-height: 2.5rem /* 40/16 */;
    color: #fff;
  }
  .state {
    position: absolute;
    width: 6.6875rem /* 107/16 */;
    height: 1.25rem /* 20/16 */;
    color: #A9A9A9;
    text-align: center;
    top: 20rem;
    left:50%;
    transform:translate(-50%,-50%);
  }
  .van-count-down {
    display: inline-block;
  }
</style>
